import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { stripeApi } from '../apis/stripe.api';
import { toast } from 'react-toastify';

const ExplorerPurchase = () => {
  const { user } = useSelector((state) => state.user);
  const [formData, setFormData] = useState({
    seats: 1,
    name: '',
    email: user?.email || '',
    companyName: user?.organization || '',
    region: 'US',
    paymentSchedule: 'yearly',
    acceptedTerms: false
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      if (!formData.name || !formData.email || !formData.companyName) {
        throw new Error('Please fill in all required fields');
      }
      console.log('RENEWAL -- Form submission data:', formData);
    
      const { url } = await stripeApi.createRenewSession(formData, 'explorer');
      
      if (!url) {
        throw new Error('No checkout URL received from server');
      }
      
      window.location.href = url;
    } catch (error) {
      console.error('Explorer purchase submission error:', error);
      toast.error(error.message || 'Payment initiation failed. Please try again.', {
        autoClose: 6000
      });
    }
  };

  return (
    <div className="max-w-2xl mx-auto p-6 bg-white rounded-lg shadow-sm">
      <div className="text-center mb-8">
        {(!user?.email || !user?.organization) && (
          <img src="/logo.png" alt="Lovenirai" className="h-8 mx-auto mb-6" />
        )}
        <h2 className="text-2xl font-bold text-gray-900">Complete Explorer Purchase</h2>
      </div>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-gray-700">Number of Seats:</label>
          {<input
            type="number"
            min="1"
            max="9"
            value={formData.seats}
            onChange={(e) => {
              const value = parseInt(e.target.value);
              if (value <= 9) {
                setFormData({...formData, seats: value});
              }
            }}
            className="mt-1 block w-full px-4 py-2 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          />}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">Name:</label>
          <input
            type="text"
            value={formData.name}
            onChange={(e) => setFormData({...formData, name: e.target.value})}
            className="mt-1 block w-full px-4 py-2 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">Email:</label>
          <input
            type="email"
            value={formData.email}
            onChange={(e) => setFormData({...formData, email: e.target.value})}
            className="mt-1 block w-full px-4 py-2 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">Company Name:</label>
          <input
            type="text"
            value={formData.companyName}
            onChange={(e) => setFormData({...formData, companyName: e.target.value})}
            className="mt-1 block w-full px-4 py-2 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            required
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">Main Region:</label>
          <select
            value={formData.region}
            onChange={(e) => setFormData({...formData, region: e.target.value})}
            className="mt-1 block w-full px-4 py-2 rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
          >
            <option value="US">US</option>
            <option value="eu">EU</option>
            <option value="ap">APAC</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Payment Schedule:</label>
          <div className="flex space-x-4">
            <button
              type="button"
              className={`px-4 py-2 rounded-md ${
                formData.paymentSchedule === 'yearly' 
                  ? 'bg-[#10193A] text-white' 
                  : 'bg-gray-100 text-gray-700'
              }`}
              onClick={() => setFormData({...formData, paymentSchedule: 'yearly'})}
            >
              Yearly
            </button>
            {false && <button
              type="button"
              className={`px-4 py-2 rounded-md ${
                formData.paymentSchedule === 'monthly' 
                  ? 'bg-[#10193A] text-white' 
                  : 'bg-gray-100 text-gray-700'
              }`}
              onClick={() => setFormData({...formData, paymentSchedule: 'monthly'})}
            >
              Monthly
            </button>}
          </div>
        </div>

        <div className="text-center text-gray-700">
          {false && <p>All plans are 1 year. Save $100/seat with Yearly prepaid.</p>}
          {false && <p className="text-2xl font-bold mt-2">${formData.paymentSchedule === 'yearly' ? '2400' : '200'}/year</p>}
          <p className="text-2xl font-bold mt-2">${process.env.REACT_APP_EXPLORER_PRICE_PER_SEAT_4QTR * formData.seats}/year</p>
            
        </div>

        <div className="flex items-center">
          <input
            type="checkbox"
            checked={formData.acceptedTerms}
            onChange={(e) => setFormData({...formData, acceptedTerms: e.target.checked})}
            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
          />
          <label className="ml-2 block text-sm text-gray-700">
            I accept the Privacy Policy, Subscription Agreement, and EULA.
          </label>
        </div>

        <button
          type="submit"
          className="w-full bg-[#10193A] text-white py-3 px-4 rounded-md hover:bg-opacity-90 transition-colors font-medium disabled:opacity-50"
          disabled={!formData.acceptedTerms}
        >
          Buy Now
        </button>
      </form>
    </div>
  );
};

export default ExplorerPurchase;
